import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Car, LogOut } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

const Navigation = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-xl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
            <div className="p-2 bg-primary/10 rounded-sm group-hover:bg-primary/20 transition-colors">
              <Car className="h-6 w-6 text-primary" />
            </div>
            <span className="heading-font text-xl font-bold tracking-wider">VIN CHECK</span>
          </Link>
          
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              data-testid="nav-about"
            >
              About
            </Link>
            {user?.is_admin && (
              <>
                <Link
                  to="/admin/dashboard"
                  className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
                  data-testid="nav-admin"
                >
                  Admin
                </Link>
                <Button
                  onClick={handleLogout}
                  variant="outline"
                  size="sm"
                  className="gap-2"
                  data-testid="nav-logout-btn"
                >
                  <LogOut className="h-4 w-4" />
                  Logout
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
